//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { IUserSession } from '../../../../helpers/user-session'

import { IIMRParemetersExtension } from "../parameters.interfaces"


// Public Types

export type BasicParameter = {
    caption: string

    color?: string
    isCheckBox?: boolean
    isHTML?: boolean
    size?: BasicParameterSize
    unit?: string
    value?: any
}

export enum BasicParameterSize {
    Normal = 0,
    Small = 1,
    Large = 2
}

export interface IBasicParametersExtension {
    setParameters(parameters: BasicParameter[]): void
}

export type BasicParametersExtensionOptions = {
    parameters: BasicParameter[]
}

// Public Types End


export class BasicParametersExtension implements IIMRParemetersExtension, IBasicParametersExtension {

    // Members

    private parameters: BasicParameter[];

    // Members End


    // Ctor

    constructor(private options: BasicParametersExtensionOptions) {
        this.setOptions()
    }

    // Ctor End


    // IIMRParametersExtension Implementation

    public initialize(userSession: IUserSession): JQueryPromise<void> {
        return $.Deferred<void>().resolve().promise()
    }

    public getPrameters(): BasicParameter[] {
        return this.parameters
    }

    public refresh(): JQueryPromise<void> {
        return $.Deferred<void>().resolve().promise()
    }

    // IIMRParametersExtension Implementation End


    // IBasicParametersExtension Implementation

    public setParameters(parameters: BasicParameter[]): void {
        this.parameters = parameters
    }

    // IBasicParametersExtension Implementation End


    // Options

    private setOptions(): void {
        if (this.options != null) {
            if (_.isArray(this.options.parameters)) {
                this.parameters = this.options.parameters
            }
        }
    }

    // Options End
}
